import React from 'react';

export const QuestionarioCasasStepOne = ({ formData, handleChange }) => {
  return (
    <div className="space-y-4" data-testid="questionario-casas-step-1">
      <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Nome completo *" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-name-input" />
      <div className="grid sm:grid-cols-2 gap-4">
        <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="E-mail *" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-email-input" />
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="Celular *" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-phone-input" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <input type="tel" name="homePhone" value={formData.homePhone} onChange={handleChange} placeholder="Telefone residencial" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-home-phone-input" />
        <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Endereço" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-address-input" />
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <select name="gender" value={formData.gender} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-gender-select">
          <option value="">Sexo</option>
          <option value="masculino">Masculino</option>
          <option value="feminino">Feminino</option>
          <option value="outro">Outro</option>
        </select>
        <select name="ageRange" value={formData.ageRange} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-age-select">
          <option value="">Faixa etária</option>
          <option value="18-25">18-25</option>
          <option value="26-35">26-35</option>
          <option value="36-45">36-45</option>
          <option value="46-60">46-60</option>
          <option value="60+">60+</option>
        </select>
        <input type="text" name="bestContactTime" value={formData.bestContactTime} onChange={handleChange} required placeholder="Melhor horário *" className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-best-contact-time-input" />
      </div>
    </div>
  );
};
